import { Config } from "../config";
import { APEvent } from "../types/Events";

export function trackEvent(event: APEvent) {
  if (Config.env === "production") {
    window.dataLayer && window.dataLayer.push(event);
  }
}
